export function focusOn (selector:string):HTMLElement {
    let inputElement:HTMLTextAreaElement|HTMLInputElement = document.querySelector(selector);
    if (inputElement) {
        inputElement.click();
        inputElement.focus();
    }
    return inputElement;

}